import { runClientComponent } from '../../_common/client/client-component-runner';
import { RecoAlternativeComponent } from './reco-alternative.component';

runClientComponent({ RecoAlternativeComponent });
